








import Vue, { PropType } from 'vue'

import { DragDropAction, DragDropService } from '../widgets/base/drag-drop'
import { Widget } from '../widgets/base'
import { WidgetHeightType } from '../widgets/base/widget/WidgetTypes'
import WidgetFactory from '../widgets/base/widget/WidgetFactory'

export default Vue.extend({
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  data() {
    return {
      dragAction: undefined as unknown as DragDropAction
    }
  },
  computed: {
    widgetCssClasses(): string[] {
      return [
        'widget--template',
        'widget-' + this.widget.type
      ]
    }
  },
  mounted() {
    const element = this.$refs.widgetTemplate as HTMLElement

    const widget = WidgetFactory.create(this.widget.type)
    if (widget === null) return
    widget.isTemplate = true

    if (!widget.heightType) {
      widget.heightType = widget.defaultHeightType || WidgetHeightType.automatic
    }

    this.dragAction = new DragDropAction(element, () => widget!)
    DragDropService.registerDragAction(this.dragAction)
  },
  destroyed() {
    if (this.dragAction) {
      DragDropService.unregisterDragAction(this.dragAction)
    }
  }
})
